import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useViewAsSupplierSelector } from 'store/features/viewAsSupplier';
import { getDeliveryTypes } from 'store/services/supplier';
import { SupplierDeliveryType } from 'types';

/** Hook to get all delivery types of the currently focused supplier's (in a supplier account, this is just the supplier, in the admin account this could be the supplier-details supplier if one is selected). */
export const useSupplierDeliveryTypes = () => {
    const [supplierDeliveryTypes, setSupplierDeliveryTypes] =
        useState<SupplierDeliveryType[]>();

    const { viewAsSupplier } = useSelector(useViewAsSupplierSelector);

    useEffect(() => {
        if (!!viewAsSupplier) {
            getDeliveryTypes(viewAsSupplier).then(
                (deliveryTypes: SupplierDeliveryType[]) => {
                    setSupplierDeliveryTypes(deliveryTypes);
                }
            );
        }
    }, [viewAsSupplier]);
    return useMemo(() => supplierDeliveryTypes, [supplierDeliveryTypes]);
};
